import React from "react";

export default function IconShare({width, height}: any) {
  return (
    <svg
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3359 14.6677L28.2693 3.73438"
        stroke="#910371"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3297 9.06406V2.66406H22.9297"
        stroke="#910371"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6641 2.66406H11.9974C5.33073 2.66406 2.66406 5.33073 2.66406 11.9974V19.9974C2.66406 26.6641 5.33073 29.3307 11.9974 29.3307H19.9974C26.6641 29.3307 29.3307 26.6641 29.3307 19.9974V17.3307"
        stroke="#910371"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
